import { IState } from '../../store';

export const selectIsInHiddenBase = (state: IState): boolean => !!state.offerData.offer.isInHiddenBase;
